import React, { Component } from 'react'
import Message from '../components/Message'
import InfoMessage from '../components/InfoMessage'
import SingleImage from '../components/SingleImage'
import SingleVideo from '../components/SingleVideo'
import Carousel from '../components/Carousel'
import Popup from '../components/Popup'
import CarouselInfoMessage from '../components/CarouselInfoMessage'
import ListButton from '../components/ListButton'
import {
  isImage,
  isCarousel,
  isVideo,
  isPopup,
  isTextMessage,
  isListButton,
  isInfoMessage,
} from '../../redux/utils'

const message_close_popup = 'CLOSE_POPUP';

const messageStyle = {
  display: 'inline-block',
  maxWidth: '70%',
  boxShadow: '0 6px 7px 0 rgba(0,0,0,0.14)',
  marginBottom: '10px',
  padding: '',
  overflow: 'hidden',
  fontSize: '16px',
}

const userMessageStyle = {
  ...messageStyle,
  borderRadius: '8px',
  padding: '6px 17px',
  backgroundColor: 'rgba(6,187,158,1.00)',
  color: 'white',
}

const botMessageStyle = {
  ...messageStyle,
  padding: '6px 17px',
  borderRadius: '6px',
  backgroundColor: '#EDEDED',
  color: '#666666',
}

const imageVideoBotMessageStyle = {
  ...botMessageStyle,
  padding: '0'
};

class ChatHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showPopup: false
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.messages.length !== this.props.messages.length) {
      const { messages } = this.props;
      if (isPopup(messages[messages.length - 1])) {
        this.setState({ showPopup: true });
      }
    }
  }
  render() {

    const {
      messages,
      isBotTyping,
      sendMessage,
      conversationId,
      sessionToken,
      userId,
      ipAddress
    } = this.props;

    const {
      showPopup
    } = this.state;

    /*eslint-disable array-callback-return*/
    const computedMessages = messages.map((message) => {
      // console.log("message", message);
      if (message.userMessage) {
        if (message.userMessage === 'ISSOU' || message.userMessage === message_close_popup) {
          return null
        } else {
          /*console.log('-------------------------------------------------------------------');
          console.log('case userMessage');
          console.log('message', message);
          message.userMessage
          ? console.log('message.userMessage', message.userMessage)
          : console.error('message.userMessage undefined', message)
          console.log('-------------------------------------------------------------------');*/
          return (
            <div
            className="containerChat user"
            key={message.id}
            >
              <span
              style={userMessageStyle}
              >
                <Message message={message.userMessage} />
              </span>
            </div>
            )
        }
      } else if (isPopup(message)) {
        const { popup } = message.entities[0];
         return  <Popup
                    key={message.id}
                    show={showPopup}
                    title={popup.title}
                    corps={popup.corps}
                    handlePopupClose={() => {
                      const params = {
                        type: 'message',
                        from: {
                          id: userId,
                          ipAddress,
                        },
                        text: message_close_popup
                      }
                      sendMessage(sessionToken, params, conversationId);
                      this.setState({ showPopup: false })
                    }}
                  />
      } else if (isTextMessage(message)) {
        /*console.log('-------------------------------------------------------------------');
        console.log('case isTextMessage');
        console.log('message', message);
        message.text
        ? console.log('message.text', message.text)
        : console.error('message.text undefined', message)
        console.log('-------------------------------------------------------------------');*/
        return (
          <div
            className="containerChat text-reply"
            key={message.id}
          >
            <span style={botMessageStyle}>
              <Message message={message.text} />
            </span>
          </div>
        )
      } else if (isInfoMessage(message)) {
        if (message.attachments.length > 1) {
          return (
            <div
              className="containerChat info-message-container"
              key={message.id}
            >
              <span className="info-message-content" style={{ ...botMessageStyle, backgroundColor: 'rgb(248, 248, 249)', boxShadow: 'none' }}>
                <CarouselInfoMessage className="info-messages" message={message.attachments} />
              </span>
            </div>
          )
        } else {
          return (
            <div
              className="containerChat info-message-container-short"
              key={message.id}
            >
              <span  className="info-message-span-content">
                <InfoMessage message={message.attachments[0].content} />
              </span>
            </div>
          )
        }
      } else if (isCarousel(message)) {
        return (
          <div
            className="containerChat carrousel-container"
            key={message.id}
          >
            <span className="carrousel-content" style={{ ...imageVideoBotMessageStyle, width: '95%', background: 'none', boxShadow: 'none', overflow: 'visible' }} key={message.id}>
              <Carousel
                className=" carrousel"
                message={message}
                last={messages.length === (messages.indexOf(message) + 1)}
                width={1000}
                secondRow={this.props.secondRow}
              />
            </span>
          </div>
        )
      } else if (message.attachments) {
        const attachment = message.attachments[0]
        if (isListButton(message)) {
          /*console.log('-------------------------------------------------------------------');
          console.log('case isListButton');
          console.log('message', message);
          console.log('message.attachments[0].content.text', message.attachments[0].content.text);
          message.attachments[0].content.text
          ? console.log('message.attachments[0].content.text', message.attachments[0].content.text)
          : console.error('message.attachments[0].content.text undefined', message)
          console.log('-------------------------------------------------------------------');*/
          return (
            <div
              className="containerChat basic-container"
              key={message.id}
            >
              <span style={botMessageStyle}>
                <Message message={message.attachments[0].content.text} />
              </span>
              <ListButton message={message} />
            </div>
          )
        } else if (isImage(message)) {
          return (
            <div
              className="containerChat image"
              key={message.id}
            >
              <span style={imageVideoBotMessageStyle}>
                <SingleImage src={attachment.contentUrl} />
              </span>
            </div>
          )
        } else if (isVideo(message)) {
          return (
            <div
              className="containerChat video"
              key={message.id}
            >
              <span style={{ ...imageVideoBotMessageStyle, minWidth: '400px' }}>
                <SingleVideo src={attachment.content.media[0].url} />
              </span>
            </div>
          )
        }
      } else {
       /* console.log('-------------------------------------------------------------------');
        console.error('case else - error handling');
        console.error('message', message);
        console.log('-------------------------------------------------------------------');*/
        return (
          <span
            style={botMessageStyle}
            key={message.id}>
            <div
              className="containerChat other-basic-container"
            >
              <span>
                <Message message="Error In Message Computing Please Contact Admin" />
              </span>
            </div>
          </span>
        )
      }
    });
    /*eslint-disable array-callback-return*/
    if (isBotTyping) {
      /*console.log('-------------------------------------------------------------------');
      console.log('case bot is typing');
      console.log('-------------------------------------------------------------------');*/
      computedMessages.push(
        <div
          key="botIsTyping"
          className="containerChat bot-typing"
        >
          <span style={{ ...botMessageStyle, fontSize: '35px' }} className="botIsTypingDots">
            <Message message="..." className="botIsTypingDots"/>
          </span>
        </div>,
      )
    }
    return (
      <div
      >
        {computedMessages}
      </div>
    )
  }
}

export default ChatHistory



// WEBPACK FOOTER //
// ./src/views/layouts/ChatHistory.js